module.exports = __webpack_public_path__ + "fonts/circular-book.9fe4b2a.woff";